export enum WorkloadViewMode {
  Agent = 'agent',
  Manager = 'manager',
  Director = 'director',
}
